import type { FaireProductEntity } from "../../entity_types/product";

export const p_hm45ntumx3: FaireProductEntity = {
  token: "p_hm45ntumx3",
  type: "product",
  name: "Glitter Bat Halloween Bow Baby Headband - Hair Accessories",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/9162834811b20be0b84242f3d4b45c6b4b676dd512fd2028c995e3f0400a60d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6db513331e604d6dcb83ddc88d8c63723baeb80b06a9a236e219be7b1749f67d.jpeg",
    "https://cdn.faire.com/fastly/c90da837a3d3063df779094c7df5555b5501f37050984101defb39a23b7ae14b.jpeg",
    "https://cdn.faire.com/fastly/134335e1273ddaf9cee0a75476a8a2bfc39a3af0707b8fd718bdebcf3e6ef11a.jpeg",
    "https://cdn.faire.com/fastly/5b1811c3267a90acceab4161fdcb36a0896db317dcd16e7f8a83049febd8a1be.jpeg",
    "https://cdn.faire.com/fastly/c937a9591b6f4b4e7fd69c0a8bf76b82e4bc6de452e52d32fef5225b44a73026.jpeg",
  ],
  priceDollars: 6,
  description:
    "Tiny but boo-tiful, this darling bat bow headband adds the sweetest spooky touch for your little pumpkin.\n\nFeatures:\n * Black glitter bow with black glitter bat wings \n * Nylon elastic hair band \n * Glitter accents are “shed free” \n * Recommended for babies 0-24 months \n\nPair this headband with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:24.662Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
